//Reload Page when Variant is selected
    jQuery(function() {
    $('.single-option-selector').on('change', function(){
        setTimeout(function(){ 
          if($('[name="id"]').val() != "{{ product.selected_or_first_available_variant.id }}"){
            location.reload();
          }
        }, 1);
    });
  });

//Cart Reload on Select -> Input
$(function() {
    $('.product-quantity-box select').change(function() {
        var this_value = $(this).val();
        $input = $(this).siblings('input'),
        $input.val(this_value);
        $input.trigger('change');
    });
});